<template>
  <div
    v-if="subcategories.length"
    class="subcat">
    <div class="subcat__container scrollbar-hidden">
      <div
        ref="tagsList"
        class="subcat__item transition--color-bg"
        :class="{ 'subcat__item--active': !isSubcategory }"
        tabindex="0"
        @click="mutateTagHandler">
        Top offers
      </div>
      <div
        v-for="(item) in subcategories"
        :key="item.id"
        class="subcat__item transition--color-bg"
        :class="{ 'subcat__item--active': activeTag.id === item.id }"
        tabindex="0"
        @click.stop="setActiveTag(item.id)">
        {{ item.title }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { flatTagsById } from 'Root/helpers/tags';

export default {
  name: 'SubcategoriesBlock',

  computed: {
    ...mapState(['activeGame']),
    ...mapState('products', ['activeTag']),

    subcategories() {
      if (this.activeTag?.parent_id) {
        if (flatTagsById[this.activeTag.parent_id]?.parent_id) {
          return flatTagsById[this.activeTag.parent_id]?._children || [];
        }

        return flatTagsById[this.activeTag.id]?._children || [];
      }

      return [];
    },

    isSubcategory() {
      return this.subcategories.find((s) => s.id === this.activeTag.id);
    },
  },

  methods: {
    ...mapMutations('products', ['mutateActiveTag']),

    setActiveTag(tagId) {
      if (tagId) {
        this.mutateActiveTag(tagId);
        this.pushByTagId(tagId);
      }
    },

    mutateTagHandler() {
      if (this.isSubcategory) {
        this.mutateActiveTag(this.activeTag.parent_id);
        this.pushByTagId(this.activeTag.id);
      } else {
        this.$router.push({ name: 'game__root', params: { namespace: this.activeGame.routeNamespace } });
      }
    },

    pushByTagId(id) {
      const categories = this.flatTagsById[id]._categories;

      this.$router.push({
        name: 'game__service',
        params: { categories, namespace: this.activeGame.routeNamespace },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .subcat__container {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: min-content;
    column-gap: 8px;
    overflow-x: auto;
    overflow-y: hidden;
    scroll-snap-type: x mandatory;

    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
  }

  .subcat__item {
    scroll-snap-align: center;
    padding: 0 12px;
    font-size: $text-13px;
    font-weight: 500;
    line-height: 40px;
    background-color: $color--basic-dark-gray;
    white-space: nowrap;
    cursor: pointer;
    color: $color--basic-white;
    border-radius: 5px;

    &--active {
      background-color: $color--basic-blue;
    }

    &:last-of-type {
      margin-right: 0;
    }

    &:hover {
      background-color: $color--basic-blue;
    }
  }
</style>
